export const APP_VERSION = "12.0";
export const APP_VERSION_LABEL = "v12.0";
